export default __webpack_public_path__ + "static/media/tipsa-canje.74356152.svg";